import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const SuccessPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center text-center p-6">
      <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg max-w-lg w-full">
        <CheckCircle className="text-green-500 w-16 h-16 mx-auto mb-6" />
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
          Félicitations ! Votre compte Ovrio est activé.
        </h1>
        <p className="text-slate-600 text-lg mb-8">
          Bienvenue dans l'équipe ! Vous pouvez maintenant profiter de toutes les fonctionnalités de votre abonnement.
        </p>
        <Link
          to="/dashboard"
          className="bg-slate-900 text-white font-bold py-3 px-6 rounded-lg hover:bg-slate-800 transition-colors shadow-sm"
        >
          Accéder à mon tableau de bord
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage;
